export const SKIP_MONTHLY_CHARGE_OPTIONS = Object.freeze([
  { value: 'scripting', label: 'Scripting Invoices' },
]);